import React from "react";
import BottomNavLayout from "../../components/BottomNavLayout";
import PubHeader from "../../components/PubHeader";
import ListOrder from "./ListOrder";

const Order = () => {
  return (
    <BottomNavLayout>
      <PubHeader title="订单列表" backToHome={true} />
      <ListOrder />
    </BottomNavLayout>
  )
}

export default Order;